{
  "name": "learning-management-system",
  "version": "4.23.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build:dev": "ng build --configuration=development",
    "build:stg": "ng build --configuration=staging",
    "build:pro": "ng build --configuration=production",
    "test": "ng test",
    "format": "npm run lint:fix && npm run pretty:fix",
    "lint": "npm run lint:quiet && npm run pretty:quiet",
    "lint:fix": "npx eslint . --ext js,json,ts,html --fix",
    "lint:quiet": "npx eslint . --ext js,json,ts,html --quiet",
    "pretty:fix": "npx prettier . --write **/*.{js,ts,html,scss,css}",
    "pretty:quiet": "npx prettier . --check **/*.{js,ts,html,scss,css}",
    "prepare": "npx husky"
  },
  "dependencies": {
    "@angular/animations": "18.2.11",
    "@angular/cdk": "^18.2.12",
    "@angular/common": "18.2.11",
    "@angular/compiler": "18.2.11",
    "@angular/core": "18.2.11",
    "@angular/forms": "18.2.11",
    "@angular/material": "^18.2.12",
    "@angular/platform-browser": "18.2.11",
    "@angular/platform-browser-dynamic": "18.2.11",
    "@angular/router": "18.2.11",
    "@contentful/rich-text-html-renderer": "~15.6.2",
    "@gamelearn/gl-style-dictionary": "^0.10.0",
    "@gamelearn/skeletor": "^2.35.9",
    "@mdi/font": "^7.4.47",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@sentry/angular": "^8.48.0",
    "@types/jquery": "^3.5.32",
    "@types/luxon": "^3.4.2",
    "@webcomponents/webcomponentsjs": "^2.8.0",
    "chart.js": "^4.4.6",
    "core-js": "^3.8.3",
    "file-saver": "^2.0.5",
    "image-conversion": "^2.1.1",
    "ion-rangeslider": "2.3.1",
    "jquery": "^3.7.1",
    "jszip": "^3.10.1",
    "jszip-utils": "^0.1.0",
    "luxon": "^3.5.0",
    "moment": "^2.29.1",
    "moment-timezone": "^0.5.46",
    "ng2-charts": "^7.0.0",
    "ngx-image-cropper": "^9.0.0",
    "ngx-uploader": "^17.0.1",
    "odata-filter-builder": "^1.0.0",
    "rxjs": "^7.8.1",
    "tslib": "^2.8.1",
    "write-excel-file": "^2.0.10",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.11",
    "@angular/cli": "18.2.11",
    "@angular/compiler-cli": "18.2.11",
    "@angular/language-service": "18.2.11",
    "@babel/eslint-parser": "^7.25.9",
    "@gamelearn/version": "^2.0.12",
    "@types/file-saver": "^2.0.7",
    "@types/jasmine": "~5.1.4",
    "@types/node": "^22.9.0",
    "@typescript-eslint/eslint-plugin": "^5.62.0",
    "@typescript-eslint/parser": "^5.62.0",
    "eslint": "^8.57.1",
    "eslint-config-prettier": "^9.1.0",
    "eslint-import-resolver-typescript": "^2.7.1",
    "eslint-plugin-html": "^8.1.2",
    "eslint-plugin-import": "^2.31.0",
    "eslint-plugin-jasmine": "^4.2.2",
    "eslint-plugin-json-format": "^2.0.1",
    "eslint-plugin-prettier": "^4.0.0",
    "husky": "^9.1.6",
    "jasmine-core": "~5.3.0",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "lint-staged": "^15.2.10",
    "prettier": "^2.8.8",
    "ts-node": "^10.9.2",
    "typescript": "5.5.4"
  },
  "engines": {
    "node": ">=20.11.1",
    "npm": ">=10.2.3"
  }
}
